__turbopack_context__.v({
  "block": "C1lRCa_block",
  "search": "C1lRCa_search",
});
